import http from "@/service/api.js"
export default {
  //获取忍3后端的用户信息
  getUserInfo() {
    return http.spGet('/apis/v1/userinfo')
  },
  ren3logout() {
    return http.spPost('/apis/v1/logout')
  },
  //获取twitch的授权地址
  getAuthUrl(data){
    //要用formdata传
    // data
    // {
    //   Uid
    // }

    // header:x-yh-appid ninja3
    return http.spGet2('/apis/v1/web/auth/url',data)
  },
  //获取twitch的账号信息
  getTwitchAccountMsg(data){
    //要用formdata传
    // data
    // {
    //   Code
    //   State
    // }

    // header:x-yh-appid ninja3
    return http.spGet2('/apis/v1/web/auth/twitch_account',data)
  },
  //绑定twitch账号
  bind(data){
    // data
    // {
    //   UID
    //   TwitchID
    // }

   // header:x-yh-appid ninja3
    return http.spPost2('/apis/v1/web/bind',data)
  },
  // 获取游戏账号绑定的twitch账号信息
  getBindTwitch(data){
    return http.spGet2('/apis/v1/web/bind',data)
  }
}
